export default "__VITE_ASSET__BzuPxl6___"